import axios from 'axios';

const initialState = {
  contactTypes: [],
  isError: false,
  errorMsg: '',
  isSuccess: false,
  isLoading: false,
};

export default {
  namespaced: true,
  state: { ...initialState },
  mutations: {
    setContactTypes(state, payload) {
      state.contactTypes = payload;
    },
    setError(state, err) {
      state.isError = true;
      state.errorMsg = err;
    },
    setIsLoading(state, bool) {
      state.isLoading = bool;
    },
    setSuccess(state, bool) {
      state.isLoading = false;
      state.isError = false;
      state.errorMsg = '';
      state.isSuccess = bool;
    },
    clearMessages(state) {
      state.isLoading = false;
      state.isError = false;
      state.errorMsg = '';
      state.isSuccess = false;
    },
  },

  actions: {
    async fetchContactTypes({ commit }) {
      try {
        commit('setIsLoading', true);
        const res = await axios.get(`${process.env.VUE_APP_ACCOUNTS_API}/users/contact-types?$limit=0`);
        commit('setContactTypes', res.data.data);
        commit('setSuccess', true);
      } catch (error) {
        commit('setError', error);
      }
    },
    async saveContactType({ commit }, payload) {
      try {
        commit('setIsLoading', true);
        delete payload.id;
        await axios.post(`${process.env.VUE_APP_ACCOUNTS_API}/users/contact-types`, payload);
        commit('setSuccess', true);
      } catch (error) {
        commit('setError', error);
      }
    },
    async updateContactType({ commit }, payload) {
      try {
        commit('setIsLoading', true);
        await axios.patch(`${process.env.VUE_APP_ACCOUNTS_API}/users/contact-types/${payload.id}`, payload);
        commit('setSuccess', true);
      } catch (error) {
        commit('setError', error);
      }
    },
    async deleteContactType({ commit }, id) {
      try {
        commit('setIsLoading', true);
        await axios.delete(`${process.env.VUE_APP_ACCOUNTS_API}/users/contact-types/${id}`);
        commit('setSuccess', true);
      } catch (error) {
        commit('setError', error);
      }
    },
  },
};
